"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrongRegionException = void 0;
const http_exception_1 = require("../http.exception");
class WrongRegionException extends http_exception_1.HttpException {
    constructor(region) {
        super(501, `Unknown state: ${region}`);
    }
}
exports.WrongRegionException = WrongRegionException;
//# sourceMappingURL=wrongRegion.exception.js.map